import { GET_JOB_PHASES } from '../../store/jobPhases/getters/getterTypes';

export default {
  computed: {
    sitePhases() {
      return this.$store.getters[GET_JOB_PHASES] || [];
    },
    reportTasksById() {
      const { tasks } = this.$store.state.ReportsModule.reportView;
      const arr = Array.isArray(tasks) ? tasks : [];
      return new Map(arr.map((t) => [t._id, t]));
    },
    activeReportSections() {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return null;
      const phase = this.sitePhases.find((p) => p._id === phaseId);
      if (!phase || !phase.reportSections || !phase.reportSections.length)
        return null;
      return phase.reportSections;
    },
  },
  methods: {
    isSectionVisible(key) {
      return (
        !this.activeReportSections || this.activeReportSections.includes(key)
      );
    },

    resolveTaskPhaseId(task) {
      const byId = this.reportTasksById;
      const visited = new Set();
      let current = task;
      while (current) {
        if (current.jobPhaseId && current.jobPhaseId !== '') {
          return current.jobPhaseId;
        }
        const parentId = current.folderId;
        if (!parentId || visited.has(parentId)) return null;
        visited.add(parentId);
        current = byId.get(parentId);
      }
      return null;
    },

    isTaskVisibleForPhase(task) {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return true;
      return this.resolveTaskPhaseId(task) === phaseId
        ? this.isSectionVisible('inspectionTasks')
        : this.isSectionVisible('additionalTasks');
    },
  },
};
